import React, { forwardRef, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
// import './CustomDateRangePicker.css'; // Your custom CSS
import DatePicker from 'react-datepicker';
import DateInputShowComponent from './DateInputShowComponent';
import { addDays } from 'date-fns';
interface CustomDateInputProps extends React.HTMLProps<HTMLButtonElement> {
  value?: string;
}
interface CustomDateRangePickerProps {
  dateRange: [Date | null, Date | null];
  setDateRange: React.Dispatch<
    React.SetStateAction<[Date | null, Date | null]>
  >;
  startDate: Date | undefined;
  setStartDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
  endDate: Date | undefined;
  setEndDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
  placeholder?: string;
}

const CustomDateRangePicker: React.FC<CustomDateRangePickerProps> = ({
  dateRange,
  setDateRange,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  placeholder,
}) => {
  const CustomDateInput = forwardRef<HTMLButtonElement, CustomDateInputProps>(
    (props, ref) => {
      const { value, onClick, placeholder } = props;
      return (
        <DateInputShowComponent
          id="date-picker"
          value={value}
          placeholder={placeholder || 'Select Date Range'}
          onClick={onClick}
          ref={ref as React.Ref<HTMLDivElement>}
          onChange={() => {
            setStartDate(undefined);
            setEndDate(undefined);
            setDateRange([null, null]);
          }}
        />
      );
    },
  );

  useEffect(() => {
    if (dateRange[0]) {
      setStartDate(dateRange[0]);
    } else {
      setStartDate(undefined);
    }

    if (dateRange[1]) {
      setEndDate(dateRange[1]);
    } else {
      setEndDate(undefined);
    }
  }, [dateRange]);

  // Calculate max date as 90 days from start date
  const maxSelectableDate = startDate
    ? new Date(startDate.getTime() + 90 * 24 * 60 * 60 * 1000)
    : undefined;

  // Calculate min date as 90 days before start date
  const minSelectableDate = startDate
    ? new Date(startDate.getTime() - 90 * 24 * 60 * 60 * 1000)
    : undefined;
  const maxAllowedEndDate = startDate ? addDays(startDate, 90) : null;
  return (
    <DatePicker
      selectsRange={true} // Date range selecting enabled
      dateFormat="dd/MM/YYYY"
      startDate={startDate}
      endDate={endDate}
      maxDate={maxAllowedEndDate || new Date()}
      minDate={minSelectableDate}
      onChange={(update: any) => {
        setDateRange(update);
      }}
      calendarStartDay={1} // Starts from Monday
      customInput={<CustomDateInput />}
      placeholderText={placeholder || 'Select Date Range'}
      className="custom-input"
    />
  );
};

export default CustomDateRangePicker;
